import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { FeeConfigRequest, FeeFormPayloadRequest } from 'src/app/domain/registration/models/fee-config/IFeeConfigRequest';
import { FeeConfigFilters } from 'src/app/domain/registration/models/fee-config/IFeeConfigFilters';
import { FeeConfig } from 'src/app/domain/registration/models/fee-config/IFeeConfig';

@Injectable({
    providedIn: 'root'
})
export class FeeConfigService {
    private readonly baseUrl = `${API_PATH}merchants`;

    constructor(private http: HttpClient) { }

    createFeeConfig(request: FeeFormPayloadRequest): Observable<FeeConfig> {
        return this.http.post<FeeConfig>(`${this.baseUrl}/fee-config`, request);
    }

    getFeeConfig(id:string): Observable<FeeConfig> {
        return this.http.get<FeeConfig>(`${this.baseUrl}/fee/${id}`);
    }

}
